import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  NavigationHelper,
  GlobalActions,
  API,
  TableBaselines,
  viAdd,
  withRouter,
} from 'vibeguide';
import SubNavigation from '../../Header/SubNavigation';
import BaselineSidebar from './Sidebar/BaselineSidebar';
import './BaselinesContainer.scss';

class BaselinesContainer extends PureComponent {
  componentDidMount() {
    const qs = NavigationHelper.getParams() || {};
    const isNew = qs.type === 'new';
    const isView = qs.baselineId && qs.type !== 'new';

    if (isNew || isView) {
      setTimeout(() => {
        this.sidebar(qs.type, qs.baselineId);
      }, 1500);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      location: {
        search,
      },
    } = this.props;

    const {
      location: {
        search: prevSearch,
      },
    } = prevProps;

    if (search !== prevSearch) {
      const qs = NavigationHelper.getParams();

      if (qs.baselineId || qs.type === 'new') {
        this.sidebar(qs.type, qs.baselineId);
      }
    }
  }

  /**
   * When the sidebar is closed
   */
  onCloseSidebar = () => {
    const {
      history,
    } = this.props;

    const url = NavigationHelper.updateParams({
      baselineId: null,
      type: null,
    }, {
      keepPage: true,
    });

    history(url);
  };

  sidebar = (type, baselineId = null) => {
    const {
      setPanel,
    } = this.props;

    setPanel({
      show: true,
      backdrop: type === 'new',
      width: 600,
      children: (
        <BaselineSidebar
          baselineId={baselineId}
          isNew={type === 'new'}
        />
      ),
      onClose: this.onCloseSidebar,
    });
  };

  render() {
    return (
      <div className="BaselinesContainer">
        <SubNavigation
          title="Audio Baselines"
          buttons={[
            {
              text: 'New Audio Baseline',
              icon: viAdd,
              color: 'primary',
              url: NavigationHelper.updateParams({
                type: 'new',
              }),
              userCan: [
                'baseline.create',
              ],
            },
          ]}
        />

        <TableBaselines
          columns={[
            '.',
            'Name',
            'Company',
            'Description',
            'Locations',
            'Modified',
            'Tags',
            '...',
          ]}
          fetch={API.Baseline.list}
          filters={{
            mediaFormat: 'audio',
          }}
          defaultSortBy={{
            label: 'Name',
            attr: 'name',
            direction: 'asc',
          }}
          paginator
          paginatorProps={{
            label: 'Baselines',
            urlPaging: true,
            urlFilters: true,
          }}
          toggle
          toggleProps={{
            label: 'Show Archived Baselines',
            tooltip: true,
          }}
          bulk
          bulkProps={{
            edit: false,
            add: false,
            block: false,
            remove: false,
            archive: true,
          }}
          rowLink={{
            baselineId: '_id',
          }}
          menuItems={[
            { name: 'Archive', userCan: 'baseline.delete' },
          ]}
        />
      </div>
    );
  }
}

const mapDispatchToProps = {
  setPanel: GlobalActions.setPanel,
};

export default withRouter(connect(null, mapDispatchToProps)(BaselinesContainer));
